export const config = {
  issuer: 'https://brtech.okta.com/oauth2/default',
  pkce: true,
  scopes: ['openid', 'profile', 'email'],
}
